import React, { useEffect, useState } from 'react';
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import Modal from './Modal';
import InputField from './InputField';
import Button from './Button';

const CustomDateRangePicker = ({ onDatesChange, fieldName,resetDateRange }) => {
    useEffect(()=>{
        resetDateRange== true && handleReset()
    }, [resetDateRange])
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [selection, setSelection] = useState({
        startDate: new Date(),
        endDate: new Date(),
        key: 'selection',
    });
    const [inputValue, setInputValue] = useState('');

    const handleSelect = (ranges) => {
        setSelection(ranges.selection);
    };
    const saveFilter = () => {
        onDatesChange(selection.startDate, selection.endDate, fieldName);
        setModalIsOpen(false);
        const formattedStartDate = selection.startDate.toLocaleDateString();
        const formattedEndDate = selection.endDate.toLocaleDateString();
        setInputValue(`${formattedStartDate} - ${formattedEndDate}`);
    }

    const handleReset = () => {
        setSelection({
            startDate: new Date(),
            endDate: new Date(),
            key: 'selection',
        });
        setInputValue('');
    };

    return (
        <div>
            <InputField
                type="text"
                label="Select Date Range"
                value={inputValue}
                onClick={() => setModalIsOpen(true)}
                readOnly
            />
            <Modal isOpen={modalIsOpen} onClose={() => setModalIsOpen(false)} size='lg'>
                <Modal.Header>Select Last Login Date range</Modal.Header>
                <Modal.Body>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <DateRangePicker
                            ranges={[selection]}
                            onChange={handleSelect}
                            editableDateInputs={true}
                            dateDisplayFormat="MM dd yyyy"
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleReset}>Reset</Button>
                    <Button onClick={() => saveFilter()}>Done</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default CustomDateRangePicker;
